import _isNil from "lodash/isNil";
import _get from "lodash/get";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { FACT_KEYS } from './constants';
export var getFact = function getFact(state, factKey) {
  return _get(state, "factory.facts.".concat(factKey), null);
};
export var getHasPendingRequestsForFact = function getHasPendingRequestsForFact(state, factKey) {
  var factPendingRequests = _get(state, "factory.pendingFacts.".concat(factKey, ".pendingRequests"));

  return !_isNil(factPendingRequests) && factPendingRequests !== 0;
};
export var getPendingRequestCountForFact = function getPendingRequestCountForFact(state, factKey) {
  return _get(state, "factory.pendingFacts.".concat(factKey, ".pendingRequests"));
}; // HOME_ADDRESS fact related selectors

export var getHomeAddressFact = function getHomeAddressFact(_ref) {
  var factory = _ref.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.HOME_ADDRESS));
};
export var getHomeAddressZillowData = function getHomeAddressZillowData(_ref2) {
  var factory = _ref2.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.HOME_ADDRESS, ".zillow"));
};
export var getHomeAddressSelfReportedHomeValue = function getHomeAddressSelfReportedHomeValue(_ref3) {
  var factory = _ref3.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.HOME_ADDRESS, ".selfReportedHomeValue"));
};
export var getHomeAddressSelfReportedHomeValueUpdatedTime = function getHomeAddressSelfReportedHomeValueUpdatedTime(_ref4) {
  var factory = _ref4.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.HOME_ADDRESS, ".selfReportedHomeValueUpdated"));
};
export var getHomeAddressHomeValue = function getHomeAddressHomeValue(_ref5) {
  var factory = _ref5.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.HOME_ADDRESS, ".homeValue"));
};
export var getHomeAddressFields = function getHomeAddressFields(state) {
  return _get(getHomeAddressFact(state), 'address');
};
export var getHomeAddressHomeValueUpdatedTime = function getHomeAddressHomeValueUpdatedTime(state) {
  return _get(getHomeAddressZillowData(state), 'homeValueUpdated') || getHomeAddressSelfReportedHomeValueUpdatedTime(state);
};
export var getHomeAddressHomeValueChange = function getHomeAddressHomeValueChange(_ref6) {
  var factory = _ref6.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.HOME_ADDRESS, ".valueChange"));
}; // REWARDS facts selectors //

export var getCloFirstTransactionBonusHasRanOut = function getCloFirstTransactionBonusHasRanOut(_ref7) {
  var factory = _ref7.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.CLO_FIRST_TRANSACTION_BONUS_02_01_2019_RUNNING_LOW));
};
export var getCloFirstTransactionBonusRunningLow = function getCloFirstTransactionBonusRunningLow(_ref8) {
  var factory = _ref8.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.CLO_FIRST_TRANSACTION_BONUS_02_01_2019_RAN_OUT));
};
export var getCloFirstTransactionBonusUserQualifies = function getCloFirstTransactionBonusUserQualifies(_ref9) {
  var factory = _ref9.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.CLO_FIRST_TRANSACTION_BONUS_02_01_2019_USER_QUALIFIES));
};
export var getCloFirstTransactionBonusUserReceived = function getCloFirstTransactionBonusUserReceived(_ref10) {
  var factory = _ref10.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.CLO_FIRST_TRANSACTION_BONUS_02_01_2019_USER_RECEIVED));
}; // Debt-related fact selectors

export var getDebtFreeDateFact = function getDebtFreeDateFact(_ref11) {
  var factory = _ref11.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.DEBT_FREE_DATE));
};
export var getDebtTotalBalanceFact = function getDebtTotalBalanceFact(_ref12) {
  var factory = _ref12.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.DEBT_TOTAL_BALANCE));
};
export var getDebtTradelinesFact = function getDebtTradelinesFact(_ref13) {
  var factory = _ref13.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.DEBT_TRADELINES));
};
export var getPreviousDebtTotalBalanceFact = function getPreviousDebtTotalBalanceFact(_ref14) {
  var factory = _ref14.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.PREVIOUS_DEBT_TOTAL_BALANCE));
};
export var getPreviousDebtTradelinesFact = function getPreviousDebtTradelinesFact(_ref15) {
  var factory = _ref15.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.PREVIOUS_DEBT_TRADELINES));
};
export var getDebtSummaryFact = function getDebtSummaryFact(_ref16) {
  var factory = _ref16.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.DEBT_SUMMARY));
};
export var getDebtSimulatorResultsFact = function getDebtSimulatorResultsFact(_ref17) {
  var factory = _ref17.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.DEBT_SIMULATOR_RESULTS));
}; // Money transfer related fact selectors

export var getMoneyTransferWealthRecommendationsFact = function getMoneyTransferWealthRecommendationsFact(_ref18) {
  var factory = _ref18.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.WEALTH_RECOMMENDATIONS));
}; // Market tab related fact selectors

export var getMarketRecBundleCreditScoreSpendFact = function getMarketRecBundleCreditScoreSpendFact(_ref19) {
  var factory = _ref19.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.MARKET_RECOMMENDATION_BUNDLE_CREDIT_SCORE_SPEND));
};
export var getMarketRecBundleCreditScoreOnlyFact = function getMarketRecBundleCreditScoreOnlyFact(_ref20) {
  var factory = _ref20.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.MARKET_RECOMMENDATION_BUNDLE_CREDIT_SCORE_ONLY));
};
export var getMarketRecBundleBestOfFact = function getMarketRecBundleBestOfFact(_ref21) {
  var factory = _ref21.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.MARKET_RECOMMENDATION_BUNDLE_BEST_OF_AWARDS));
};
export var getAllMarketRecBundleFacts = function getAllMarketRecBundleFacts(state) {
  var _ref22;

  return _ref22 = {}, _defineProperty(_ref22, FACT_KEYS.MARKET_RECOMMENDATION_BUNDLE_BEST_OF_AWARDS, getMarketRecBundleBestOfFact(state)), _defineProperty(_ref22, FACT_KEYS.MARKET_RECOMMENDATION_BUNDLE_CREDIT_SCORE_ONLY, getMarketRecBundleCreditScoreOnlyFact(state)), _defineProperty(_ref22, FACT_KEYS.MARKET_RECOMMENDATION_BUNDLE_CREDIT_SCORE_SPEND, getMarketRecBundleCreditScoreSpendFact(state)), _ref22;
};
export var getAllCreditFactorsFact = function getAllCreditFactorsFact(_ref23) {
  var factory = _ref23.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.ALL_CREDIT_FACTORS));
};
export var getAllCreditFactorTipsFact = function getAllCreditFactorTipsFact(_ref24) {
  var factory = _ref24.factory;
  return _get(factory, "facts.".concat(FACT_KEYS.ALL_CREDIT_FACTOR_TIPS));
};
export var getDepositAccountLowYieldAccountsAPYDetails = function getDepositAccountLowYieldAccountsAPYDetails(state) {
  return _get(getFact(state, FACT_KEYS.DEPOSIT_ACCOUNT_DETAILS), 'low_yield_savings');
};
export var getDepositAccountHighYieldAccountsAPYDetails = function getDepositAccountHighYieldAccountsAPYDetails(state) {
  return _get(getFact(state, FACT_KEYS.DEPOSIT_ACCOUNT_DETAILS), 'high_yield_savings');
};